import { render, staticRenderFns } from "./DocumentsHorizontalFilters.vue?vue&type=template&id=a3d50400&scoped=true"
import script from "./DocumentsHorizontalFilters.vue?vue&type=script&lang=js"
export * from "./DocumentsHorizontalFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d50400",
  null
  
)

export default component.exports